/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".comimg[_ngcontent-%COMP%]{max-width:100%;height:auto;clear:both;display:block;margin:0 auto}.q-cards[_ngcontent-%COMP%]   .card[_ngcontent-%COMP%]{width:100%!important;height:220px!important}"];
export { styles as styles };

